const AZIMUTH = 0;
const ELEVATION = 1;
const AZI_DEEG_PER_STEP = (1.8/228)/(150/11);
const ELE_DEG_PER_STEP = (1.8/228)/(240/11);

function getMotors(arm) {
    //1,3,5,7 Azimuth motors arm 1 - 4 in order
    //2,4,6,8 Elevation motors arm 1 - 4 in order
    let ele = arm * 2;
    let azi = ele - 1;
    return [azi, ele];
}

function getAnglePayload(angle) {
    let payload = Math.round((angle + 180) * 100).toString(16);
    let pad = angle >= 0 ? '0' : 'F';

    while (payload.length < 4){
        payload = pad + payload;
    }

    return payload;
}

function getMotorPayload(motor){
    //Set a bit to 1 in corresponding motor position (ex motor 6 should be 00100000 or 20 in hex)
    let motorFlag = (0 | 1 << motor - 1).toString(16);
    return ('0' + motorFlag).slice(-2);
}

export function buildMovePayload(arm, axis, dir, step) {
    let commandCode = '23';
    let angle;

    // if (axis === ELEVATION) {
    //     angle = dir * (step * 1.666);
    // } else {
    //     angle = dir * step;
    // }
    angle = dir * step;
    let motors = getMotors(arm);
    let motor = motors[axis];

    return `${commandCode},${getMotorPayload(motor)}${getAnglePayload(angle)}`;
}

export function parseTrackerStatus(statusString) {
    let trackerStatus = {};
    let lines = statusString.split('\n');

    lines.forEach((line) => {
        if (line.includes(':')) {
            let kv = line.split(':').map((x) => x.trim().replace(/\s+/g,'_').toLocaleLowerCase());
            trackerStatus[kv[0]] = kv[1];
        }
        else if (line.match(/[1-4](\s+)-?[0-9]+(\s+)-?[0-9]+/)) {
            if (trackerStatus.arms == null) trackerStatus.arms = {};

            let armStatus = line.trim().split(/\s+/g);
            trackerStatus.arms[armStatus[0]] = {};
            trackerStatus.arms[armStatus[0]].azi = parseInt(armStatus[1]);
            trackerStatus.arms[armStatus[0]].ele = parseInt(armStatus[2]);
        }
    });

    if (trackerStatus.register) {
        trackerStatus.control_flags = parseInt(trackerStatus.register.substring(10,3), 16);
        let reed_flags = parseInt(trackerStatus.register.substr(13,2), 16);

        for (let i = 1; i < 5; i++) {
            trackerStatus.arms[i].azi_reed_engaged = Boolean(reed_flags & 1 << (i - 1) * 2);
            trackerStatus.arms[i].ele_reed_engaged = Boolean(reed_flags & 1 << (i * 2) - 1);
        }
    }

    trackerStatus.timestamp = new Date();
    return trackerStatus;
}

export function parseReedRanges(reedString) {
    let reedRanges = {};
    let arm;
    let lines = reedString.split('\n');

    lines.forEach((line) => {
        if (line.match(/Arm\s+[1-4]:\s*/)) {
            arm = parseInt(line.replace('Arm','').trim());
        }
        else if (line.match(/On\s+Range:\s+A:[0-9]+\s+E:[0-9]+\s*/)) {
            reedRanges[arm] = reedRanges[arm] || {};
            reedRanges[arm].azi = reedRanges[arm].azi || {};
            reedRanges[arm].ele = reedRanges[arm].ele || {};

            reedRanges[arm].azi.on = parseInt(line.replace(/On\s+Range:\s+A:/,'').trim()) * AZI_DEEG_PER_STEP;
            reedRanges[arm].ele.on = parseInt(line.replace(/On\s+Range:\s+A:[0-9]+\s+E:/,'').trim()) * ELE_DEG_PER_STEP;
        }
        else if (line.match(/Off\s+Range:\s+A:[0-9]+\s+E:[0-9]+\s*/)) {
            reedRanges[arm] = reedRanges[arm] || {};
            reedRanges[arm].azi = reedRanges[arm].azi || {};
            reedRanges[arm].ele = reedRanges[arm].ele || {};

            reedRanges[arm].azi.off = parseInt(line.replace(/Off\s+Range:\s+A:/,'').trim()) * AZI_DEEG_PER_STEP;
            reedRanges[arm].ele.off = parseInt(line.replace(/Off\s+Range:\s+A:[0-9]+\s+E:/,'').trim()) * ELE_DEG_PER_STEP;
        }
    });

    return reedRanges;
}

export function parseRegister(register, arm) {
    if (register) {
        register = register.slice(2, 10);
        const index = (arm - 1) * 2;
        register = register.slice(index, index + 2);
    }

    return register;
}
